import backendApi from "../../api/backendApi";
import {
  CREATE_USER_QUERY,
  GET_USER_AVAILABLE_BALANCE,
  LOGIN_QUERY,
  OTP_VERIFY_QUERY,
  Update_USER_Mutation,
  GET_USER_ORGANIZATION_DATA,
} from "../../constants/queries/user";
import { errorToast } from "../../utils/toasts";
import { AppDispatch } from "../store";
import { SET_CURRENT_USER, SET_LOGGEDIN_USER } from "./loggedInUser.types";
import { setLoadingState } from "../loader/loader.actions";
import { updateNewCheckoutState } from "../newCheckout/newCheckout.actions";

export const setLoggedInUser = (data: any) => (dispatch: AppDispatch) => {
  dispatch({
    type: SET_LOGGEDIN_USER,
    payload: data,
  });
  if (data && data._id) {
    dispatch(updateNewCheckoutState({ newCheckoutFlow: false }));
  } else {
    dispatch(updateNewCheckoutState({ newCheckoutFlow: true }));
  }
};

export const signUp =
  (user: any, cb: Function, showErrorToast = true) =>
  async (dispatch: AppDispatch) => {
    try {
      const userRes = await backendApi.post("/", {
        query: CREATE_USER_QUERY,
        variables: {
          email: user.email.toLowerCase(),
          name: user.name,
          mobile: parseFloat(user.mobile),
          countryCode: parseInt(user.countryCode),
          type: user.type,
          device: user.device,
          device_type: user.device_type,
          page_url: user.page_url,
          user_agent: user.user_agent,
          user_ip_address: user.user_ip_address,
          source: user.source,
          country: user.country,
          // company: user.'company,'
          gst: user.gst,
        },
      });
      if (userRes.data.errors?.length)
        throw new Error(userRes.data.errors[0].message);
      localStorage.setItem(
        "ezyLegalUserData",
        JSON.stringify(userRes.data.data.createUser)
      );
      dispatch(setLoggedInUser(userRes.data.data.createUser));
      cb();
    } catch (e) {
      if (showErrorToast)
        if (e instanceof Error) errorToast(e.message);
        else cb();
    }
  };
export const Update_User_Profile =
  (user: any, logingUserData: any, cb: Function) =>
  async (dispatch: AppDispatch) => {
    try {
      const userRes = await backendApi.post("/", {
        query: Update_USER_Mutation,
        variables: {
          _id: logingUserData._id,
          city: user.city || "",
          company: user.companyName || "",
          country_code: logingUserData.country_code || "",
          email: user.email.toLowerCase(),
          gst: user.gst || "",
          mobile: parseFloat(user.number),
          name: user.name,
          state: user.state,
        },
      });
      if (userRes.data.errors?.length)
        throw new Error(userRes.data.errors[0].message);
      localStorage.setItem(
        "ezyLegalUserData",
        JSON.stringify(userRes.data.data.updateUser)
      );
      dispatch(setLoggedInUser(userRes.data.data.updateUser));
      cb();
    } catch (e) {
      dispatch(setLoadingState(false));
      if (e instanceof Error) errorToast(e.message);
    }
  };

export const loginUser =
  (data: any, cb: any) => async (dispatch: AppDispatch) => {
    try {
      const userRes = await backendApi.post("/", {
        query: LOGIN_QUERY,
        variables: {
          mobile: parseFloat(data.mobile),
          countryCode: parseInt(data.countryCode),
        },
      });
      if (userRes.data.errors?.length)
        throw new Error(userRes.data.errors[0].message);
      cb();
    } catch (e) {
      if (e instanceof Error) errorToast(e.message);
    }
  };

export const verifyOrganizationApproval =
  (data: any) => async (dispatch: AppDispatch) => {
    try {
      const userRes = await backendApi.post("/", {
        query: GET_USER_ORGANIZATION_DATA,
        variables: {
          userId: data.userId,
        },
      });
      if (userRes.data.data.getUser) {
        JSON.stringify(userRes.data.data.getUser),
          dispatch(setLoggedInUser(userRes.data.data.getUser));
      }
    } catch (e) {
      dispatch(setLoadingState(false));
      if (e instanceof Error) errorToast(e.message);
    }
  };
export const verifyOtp =
  (data: any, cb: Function) => async (dispatch: AppDispatch) => {
    try {
      const userRes = await backendApi.post("/", {
        query: OTP_VERIFY_QUERY,
        variables: {
          mobile: parseFloat(data.mobile),
          country_code: parseFloat(data.countryCode),
          otp: parseFloat(data.otp),
        },
      });
      if (userRes.data.errors?.length)
        throw new Error(userRes.data.errors[0].message);
      localStorage.setItem(
        "ezyLegalUserData",
        JSON.stringify(userRes.data.data.verifyOtp)
      );
      dispatch(setLoggedInUser(userRes.data.data.verifyOtp));
      cb();
    } catch (e) {
      dispatch(setLoadingState(false));
      if (e instanceof Error) errorToast(e.message);
    }
  };

interface GetCurrentUserOption {
  userId: string;
}

export const getCurrentUser =
  (data: GetCurrentUserOption) => async (dispatch: AppDispatch) => {
    try {
      const userRes = await backendApi.post("/", {
        query: GET_USER_AVAILABLE_BALANCE,
        variables: data,
      });
      if (userRes.data.errors?.length) {
        throw new Error(userRes.data.errors[0].message);
      }

      dispatch({
        type: SET_CURRENT_USER,
        payload: userRes.data.data.getUser,
      });
    } catch (e) {
      if (e instanceof Error) {
        errorToast(e.message);
      }
    }
  };

export const setUserData = (data: any) => (dispatch: AppDispatch) => {
  dispatch({
    type: SET_CURRENT_USER,
    payload: data,
  });
};
